<template>
  <div>
    <v-expansion-panels
      v-model="panel"
      popout
      inset
      focusable
      multiple
    >
      <template v-for="(compras_, i) in array_compras">
        <v-expansion-panel>
            <v-expansion-panel-header disable-icon-rotate>
              {{compras_.id}}
              <v-divider class="mx-4" inset vertical></v-divider>
              Fecha de Compra: {{compras_.fecha_registro_formateada}}
              <v-divider class="mx-4" inset vertical></v-divider>
              Fecha de Pago: {{compras_.fecha_pago_formateada}}
              <v-divider class="mx-4" inset vertical></v-divider>
              Importe Q : <strong>{{compras_.importe_total}}</strong>
              <template v-slot:actions>
                <v-icon :color="compras_.estado == 'PEND_PAGO' ? 'warning' : 'success'"> 
                  {{compras_.estado == 'PEND_PAGO' ? 'mdi-credit-card-outline' : 'mdi-check'}}
                </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ul>
                <li>Nit: {{compras_.nit}}</li>
                <li>Correo Electrónico: {{compras_.correo_electronico}}</li>
                <li>Productos comprados (cantidad): {{compras_.compraDetalles.length}}</li>
              </ul>
              <v-card-title class="text-center">Detalle de la compra</v-card-title>
              <v-card
                flat
                dense 
                v-for="(recarga_, r1) in compras_.compraDetalles"
                :hover="true"
                :class="`recarga_${recarga_.id} mb-1`">
                <v-divider></v-divider>
                <v-card-title class="pb-0">
                  {{recarga_.descripcion}}
                  <v-chip label x-small class="ma-2">{{recarga_.tipo_producto}}</v-chip>
                </v-card-title>
                <v-card-text>
                  <ul>
                    <li>Valor Q {{ recarga_.valor }}</li>
                  </ul>
                </v-card-text>
                  <v-card-actions>
                    <v-btn 
                      v-if="$route.name != 'historial-compras'"
                      @click="ActivarAdmin(compras_)">
                      Pago manual
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                      v-if="$route.name == 'historial-compras'"
                      :loading="recarga_.loading"
                      :disabled="recarga_.estado == 'ACTIVO'"
                      @click="activarCompra(recarga_)">
                      <v-icon left>
                        {{recarga_.estado == 'ACTIVO' ? 'mdi-checkbox-marked-circle-outline' : 'mdi-check-underline' }}
                      </v-icon>
                      Activar
                    </v-btn>
                  </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-expansion-panels>

    <v-dialog v-model="dialog" v-if="dialog" persistent max-width="700px">
      <v-card>
        <v-form                       
          ref="formFirma" 
          @submit.prevent="postActivarPlanAdmin"
          v-model="validForm" 
          lazy-validation>
          <v-card-title>
            <span class="headline">Activar Plan | Id {{ current_item.id }} | Importe Total Q {{ current_item.importe_total }} </span>
          </v-card-title>
          <v-card-text>
            <v-text-field 
              v-model="uuid"  
              :rules="[rules.required]"
              label="UUID de la factura">
            </v-text-field>    
            <v-text-field 
              v-model="numero_referencia"  
              :rules="[rules.required]"
              label="Referencia">
            </v-text-field>
          
            <v-dialog
              ref="dialog2"
              v-model="modal"
              :return-value.sync="fecha_autorizacion"
              persistent
              width="290px"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fecha_autorizacion"
                  label="Fecha de compra"
                  readonly
                  :rules="[rules.required]"
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
              </template>
              <v-date-picker 
                locale="es"
                v-model="fecha_autorizacion" 
                scrollable>
                <v-btn text color="primary" @click="modal = false">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="$refs.dialog2.save(fecha_autorizacion)">Seleccionar</v-btn>
              </v-date-picker>
            </v-dialog>
      
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue" text @click="dialog = false">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              type="submit"
              color="primary" 
              :loading="loading"
              :disabled="!validForm">
              Activar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
  
export default {
  components: { 

  },
  data: function() {
    return {
      modal: false,
      panel: [],
      panel_planes: [],
      array_compras: [],
      agrupador_id: null,
      dialog: false,
      validForm: true,
      uuid: null,
      loading: false,
      numero_referencia: null,
      fecha_autorizacion: new Date().toISOString().substr(0, 10),
      codigo_referencia_cliente: null,
      current_item: null,
      rules: {
        required: value => !!value || 'Requerido',
        email: [
          v => !!v || 'Campo requerido',
          v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
        ],
      },
    };
  },
  created() {
    if(this.$route.name == "historial-compras"){
      this.agrupador_id = this.$store.state.user.agrupador_id
    } else {
      this.agrupador_id = this.$route.params.id;
    }
  },
  mounted() {
    this.getCompras();
    //console.log(this.$route);
  },
  methods: {
    getCompras() {
      let getCompras = axios.get('Compra/listar_compras_agrupador?agrupador_id='+ this.agrupador_id, { 'headers': this.$store.state.user.headers });
      return getCompras.then((callback) =>
      {
        this.array_compras = callback.data;
      }).catch((error) => {
        console.log("ERROR EN EL CALLBACK" + error);
      });
    },
    activarCompra(recarga){
      recarga.loading = true;
      let postcompra = axios.post('Compra/Activar', { "compra_detalle_id" : recarga.id }, { 'headers': this.$store.state.user.headers })
      return postcompra.then((callback) => {
        console.log(callback);
        if(callback.status == 200) {
          recarga.loading = false;
          recarga.estado = 'ACTIVO';
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Activado con éxito' });
        }
      }).catch((error) => {
        recarga.loading = false;
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
      });
    },
    modalActivarAdmin(plan) {
      this.current_item = plan;
      this.codigo_referencia_cliente = plan.codigo_referencia_cliente
      setTimeout(() => {
        this.dialog = true;
      },500);
    },
    postActivarPlanAdmin(){
      let _thisvf = this;
      if (this.$refs.formFirma.validate()) 
      {
        this.loading = true;
        let postSocitud = axios.post('Compra/registrar_pago', {
          "uuid": this.uuid, 
          "numero_referencia": this.numero_referencia,
          "fecha_autorizacion": this.fecha_autorizacion,  
          "codigo_referencia_cliente": this.codigo_referencia_cliente,
        }, { 'headers': this.$store.state.user.headers })
        return postSocitud.then((callback) => 
        {
          if(callback.status == 200) {
            this.dialog = false;
            this.loading = false;
            this.$refs.formFirma.reset();
            this.current_item.estado = "PAGADO";
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Activación correcta' });
          }
        }).catch((error) => {
          this.dialog = false;
          this.loading = false;
          this.$refs.formFirma.reset();
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
        });
      }
    }
  },
};
</script>